import { lazy } from 'react';

export const FirstAuthPage = lazy(() =>
  import('./ui/FirstAuthPage').then((module) => ({
    default: module.FirstAuthPage,
  }))
);
